import { copy } from 'ember-copy';

const capacitorExponents = [-12, -9, -6];
const gainExponents = [0, 3, 6];
const decadesMultiplier = [1, 10, 100];

export function generateRange(series, exponents) {
  var possibleValues = [];
  for (var i = 0; i < exponents.length; i++) {
    for (var j = 0; j < decadesMultiplier.length; j++) {
      for (var k = 0; k < series.length; k++) {
        var strValue = series[k] * decadesMultiplier[j] + 'e' + exponents[i];
        var item = parseFloat(strValue);

        if (item > 100) {
          item = Math.round(item);
        }

        possibleValues.push(item);
      }
    }
  }

  return possibleValues;
}

export function generateCapacitorRange(series) {
  var indexOf10 = series.indexOf(10);
  var copySeries = copy(series);
  copySeries.splice(indexOf10, 1);
  var result = generateRange(copySeries, capacitorExponents);
  return result;
}

export function generateGainRange(series) {
  var indexOfOne = series.indexOf(1);
  var indexOfTen = series.indexOf(10);
  var copySeries = copy(series);
  if (indexOfOne !== -1 && indexOfTen !== -1) {
    copySeries.splice(indexOfTen, 1);
  }

  var result = generateRange(copySeries, gainExponents);
  return result;
}

export function getMinimumValueIndex(values, minimum, precision) {
  var startingValue = values.filter((p) => p >= minimum)[0];
  var result = indexOfWithPrecision(values, startingValue, precision);

  if (startingValue < minimum) {
    result += 1;
  }

  return result;
}

export function getMaximumValueIndex(values, maximum, precision) {
  var endingValue = values.filter((p) => p <= maximum).slice(-1)[0];
  var result = indexOfWithPrecision(values, endingValue, precision);
  return result;
}

export function getValueIndex(values, minimum, maximum, value, precision) {
  var valueIsValid = maximum >= value && minimum <= value;
  var result = indexOfWithPrecision(values, value, precision);

  if (result === -1 && valueIsValid) {
    let startingBracket = values.filter((p) => p < value).slice(-1)[0];
    let endingBracket = values.filter((p) => p > value)[0];
    let resultValue = null;
    let differenceValueToStarting = value - startingBracket;
    let differenceValuesToEnding = endingBracket - value;

    // if value greater than maximum, choose the lower value, the starting bracket.
    if (value >= maximum) {
      resultValue = startingBracket;
    }

    // if value is less than minimum, choose the higher value, the ending bracket.
    else if (value <= minimum) {
      resultValue = endingBracket;
    }

    // if value is within the limits.
    else {
      // get the closer one. Works if value is within limits.
      if (differenceValueToStarting < differenceValuesToEnding) {
        resultValue = startingBracket;
      } else {
        resultValue = endingBracket;
      }
    }

    result = indexOfWithPrecision(values, resultValue, precision);
  }

  return result;
}

export function indexOfWithPrecision(values, value, precision) {
  let result = -1;

  if (typeof value !== 'undefined' && value !== null && precision !== null) {
    let val = value.toPrecision(precision);
    for (let i = 0; i < values.length; i++) {
      var item = values[i].toPrecision(precision);
      if (item === val) {
        result = i;
        break;
      }
    }
  }

  return result;
}
